import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import {
    AgregarFormulario,
    EditarFormulario,
    ObtenerFormularioPorId
} from '../../../../servicios/ServicioFormulario';
import {
    ObtenerPreguntasPorFormulario,
    AgregarPregunta,
    EditarPregunta,
    EliminarPregunta
} from '../../../../servicios/ServicioPreguntaFormulario';

const nuevaPregunta = (orden) => ({
    IdPregunta: null,
    Texto: '',
    Tipo: 'likert',       
    Orden: orden,
    Requerida: true,
    Activa: true
});

const tipos = [
    { value: 'likert', label: 'Escala (1-5)' },
    { value: 'sino', label: 'Sí/No' },
    { value: 'abierta', label: 'Abierta' },
];

export const FormularioEditor = () => {
    const { id } = useParams(); 
    const history = useHistory();

    const esNuevo = String(id) === '0';

    const [formulario, setFormulario] = useState({
        IdFormulario: 0,
        Nombre: '',
        Descripcion: '',
        Activo: true
    });

    const [preguntas, setPreguntas] = useState([]);
    const [guardando, setGuardando] = useState(false);
    const [cargando, setCargando] = useState(false);

    const cargar = async () => {
        if (esNuevo) return;
        setCargando(true);

        const f = await ObtenerFormularioPorId(Number(id));
        if (f) {
            setFormulario({
                IdFormulario: f.idFormulario ?? f.IdFormulario,
                Nombre: f.nombre ?? f.Nombre,
                Descripcion: f.descripcion ?? f.Descripcion,
                Activo: f.activo ?? f.Activo
            });
        }
        const ps = await ObtenerPreguntasPorFormulario(Number(id));
        setPreguntas(Array.isArray(ps) ? ps.map(p => ({
            IdPregunta: p.idPregunta ?? p.IdPregunta,
            IdFormulario: p.idFormulario ?? p.IdFormulario,
            Texto: p.texto ?? p.Texto,
            Tipo: p.tipo ?? p.Tipo,
            Orden: p.orden ?? p.Orden,
            Requerida: p.requerida ?? p.Requerida,
            Activa: p.activa ?? p.Activa,
        })) : []);
        setCargando(false);
    };

    useEffect(() => { cargar(); /* eslint-disable-next-line */ }, [id]);

    const addPregunta = () => {
        const nextOrden = (preguntas[preguntas.length - 1]?.Orden ?? preguntas.length) + 1;
        setPreguntas([...preguntas, nuevaPregunta(nextOrden)]);
    };

    const updatePregunta = (idx, key, value) => {
        const copy = [...preguntas];
        copy[idx] = { ...copy[idx], [key]: value };
        setPreguntas(copy);
    };

    const removePregunta = async (idx) => {
        const p = preguntas[idx];
        if (p.IdPregunta) {
            const res = await EliminarPregunta(p.IdPregunta);
            if (res?.indicador !== 0) {
                alert(res?.mensaje || 'No se pudo eliminar');
                return;
            }
        }
        const copy = [...preguntas];
        copy.splice(idx, 1);
        // reordenar
        setPreguntas(copy.map((x, i) => ({ ...x, Orden: i + 1 })));
    };

    const guardar = async () => {
        if (!formulario.Nombre?.trim()) {
            alert('El nombre es requerido');
            return;
        }

        setGuardando(true);

        
        let idFormulario = formulario.IdFormulario;

        if (esNuevo) {
            
            const res = await AgregarFormulario({
                Nombre: formulario.Nombre,
                Descripcion: formulario.Descripcion,
                Activo: true
            });
            if (res?.indicador !== 0) {
                alert(res?.mensaje || 'No se pudo crear el formulario');
                setGuardando(false);
                return;
            }
            idFormulario = res.valor ?? res.idNuevo ?? res.IdNuevo;
        } else {
            const res = await EditarFormulario({
                IdFormulario: idFormulario,
                Nombre: formulario.Nombre,
                Descripcion: formulario.Descripcion,
                Activo: formulario.Activo
            });
            if (res?.indicador !== 0) {
                alert(res?.mensaje || 'No se pudo editar el formulario');
                setGuardando(false);
                return;
            }
        }

       
        for (const p of preguntas) {
            const payload = {
                IdPregunta: p.IdPregunta,
                IdFormulario: idFormulario,
                Texto: p.Texto,
                Tipo: p.Tipo,
                Orden: p.Orden,
                Requerida: p.Requerida,
                Activa: p.Activa
            };

            if (!p.IdPregunta) {
                const r = await AgregarPregunta(payload);
                if (r?.indicador !== 0) {
                    alert(r?.mensaje || 'No se pudo agregar una pregunta');
                    setGuardando(false);
                    return;
                }
            } else {
                const r = await EditarPregunta(payload);
                if (r?.indicador !== 0) {
                    alert(r?.mensaje || 'No se pudo editar una pregunta');
                    setGuardando(false);
                    return;
                }
            }
        }

        setGuardando(false);
        alert('Guardado correctamente');
        history.push('/formulario_catalog');
    };

    return (
        <div className="p-6 space-y-4">
            <div className="flex items-center justify-between">
                <h1 className="text-xl font-bold">{esNuevo ? 'Nuevo formulario' : 'Editar formulario'}</h1>
                <button
                    className="px-4 py-2 rounded bg-gray-200"
                    onClick={() => history.push('/formulario_catalog')}
                >
                    Volver
                </button>
            </div>

            {cargando ? (
                <p>Cargando...</p>
            ) : (
                <>
                    <div className="grid md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium">Nombre</label>
                            <input
                                className="w-full border p-2 rounded"
                                value={formulario.Nombre}
                                onChange={(e) => setFormulario({ ...formulario, Nombre: e.target.value })}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium">Descripción</label>
                            <input
                                className="w-full border p-2 rounded"
                                value={formulario.Descripcion ?? ''}
                                onChange={(e) => setFormulario({ ...formulario, Descripcion: e.target.value })}
                            />
                        </div>
                    </div>

                    <hr className="my-4" />

                    <div className="flex items-center justify-between">
                        <h2 className="font-semibold">Preguntas</h2>
                        <button className="px-3 py-2 rounded bg-blue-600 text-white" onClick={addPregunta}>
                            Agregar pregunta
                        </button>
                    </div>

                    <div className="space-y-3 mt-2">
                        {preguntas.map((p, idx) => (
                            <div key={idx} className="border rounded p-3">
                                <div className="grid md:grid-cols-12 gap-3 items-center">
                                    <div className="md:col-span-1">
                                        <label className="text-xs">Orden</label>
                                        <input
                                            type="number"
                                            min={1}
                                            className="w-full border p-2 rounded"
                                            value={p.Orden}
                                            onChange={(e) => updatePregunta(idx, 'Orden', Number(e.target.value))}
                                        />
                                    </div>

                                    <div className="md:col-span-6">
                                        <label className="text-xs">Texto</label>
                                        <input
                                            className="w-full border p-2 rounded"
                                            value={p.Texto}
                                            onChange={(e) => updatePregunta(idx, 'Texto', e.target.value)}
                                        />
                                    </div>

                                    <div className="md:col-span-2">
                                        <label className="text-xs">Tipo</label>
                                        <select
                                            className="w-full border p-2 rounded"
                                            value={p.Tipo}
                                            onChange={(e) => updatePregunta(idx, 'Tipo', e.target.value)}
                                        >
                                            {tipos.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                                        </select>
                                    </div>

                                    <div className="md:col-span-1">
                                        <label className="text-xs">Req.</label>
                                        <input
                                            type="checkbox"
                                            className="mt-3"
                                            checked={!!p.Requerida}
                                            onChange={(e) => updatePregunta(idx, 'Requerida', e.target.checked)}
                                        />
                                    </div>

                                    <div className="md:col-span-1">
                                        <label className="text-xs">Activa</label>
                                        <input
                                            type="checkbox"
                                            className="mt-3"
                                            checked={!!p.Activa}
                                            onChange={(e) => updatePregunta(idx, 'Activa', e.target.checked)}
                                        />
                                    </div>

                                    <div className="md:col-span-1 flex justify-end">
                                        <button
                                            className="px-3 py-2 rounded bg-red-600 text-white mt-4 md:mt-6"
                                            onClick={() => removePregunta(idx)}
                                        >
                                            Eliminar
                                        </button>
                                    </div>
                                </div>
                                {p.Tipo === 'likert' && (
                                    <p className="text-xs text-gray-600 mt-2">
                                        Escala fija 1–5 (definida por estándar).
                                    </p>
                                )}
                            </div>
                        ))}

                        {preguntas.length === 0 && (
                            <p className="text-sm text-gray-600">No hay preguntas agregadas.</p>
                        )}
                    </div>

                    <div className="flex justify-end space-x-3 mt-6">
                        <button
                            disabled={guardando}
                            className="px-4 py-2 rounded bg-emerald-600 text-white disabled:opacity-60"
                            onClick={guardar}
                        >
                            {guardando ? 'Guardando...' : 'Guardar'}
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default FormularioEditor;